module.exports = "/images/ny-life2-8.jpg";